<fui-checkbox-control [label]="label(option)" [(ngModel)]="valued" class="option"
                      [allowLabelMarkup]="allowLabelMarkup"
                      (focussed$)="onFocussed($event)"></fui-checkbox-control>
<fui-icon *ngIf="optionOpenable" [height]="16" [icon]="'chevron-right'" [width]="16" class="action"
          (click)="openOption($event)"></fui-icon>
